import React from 'react'
import { FormProvider, useController, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useLocationEditModalProviderContextValue } from '../context/LocationEditModalProvider'
import { locationEditSchema, LocationEditSchema } from '../locationEditSchema'
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Message,
  Text,
} from '@workwhile/ui'
import { getAddressString } from 'lib/address'

export function LocationEditModalMain() {
  const {
    state: { location, mutationState },
    actions: { updateLocation },
  } = useLocationEditModalProviderContextValue()

  const methods = useForm<LocationEditSchema>({
    resolver: zodResolver(locationEditSchema),
    defaultValues: {
      hidden: location.hidden,
    },
  })

  const { control, handleSubmit } = methods

  const onFormSubmit = handleSubmit(updateLocation)

  const { field } = useController({
    control,
    name: 'hidden',
  })

  return (
    <FormProvider {...methods}>
      <form onSubmit={onFormSubmit}>
        <Flex flexDirection="column" gap={3}>
          <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
            Edit Location {location.name} ({location.id})
          </Heading>

          <Flex flexDirection="column" gap={1}>
            <Box>
              <Text fontSize={2} fontWeight="bold">
                Name
              </Text>
              <Text>{location.name}</Text>
            </Box>

            <Box>
              <Text fontSize={2} fontWeight="bold">
                Address
              </Text>
              <Text>
                {getAddressString({
                  ...location.address,
                  zip: location.address.zip.toString(),
                })}
              </Text>
            </Box>
          </Flex>

          <Checkbox {...field}>Hide location from shift creation</Checkbox>

          {mutationState.errorMessage ? (
            <Message variant="error" mt={3} borderRadius="small">
              {mutationState.errorMessage}
            </Message>
          ) : null}

          <Flex flexDirection="row" justifyContent="flex-end">
            <Button
              variant="primary"
              type="submit"
              disabled={mutationState.isPending}
            >
              {mutationState.isPending ? 'Saving...' : 'Save'}
            </Button>
          </Flex>
        </Flex>
      </form>
    </FormProvider>
  )
}
